<template>
  <div class="max-w-5xl mx-auto">
    <div class="bg-white rounded-xl shadow-md overflow-hidden">
      <div class="p-8">
        <!-- Title -->
        <h1 class="text-3xl font-bold text-gray-800 mb-6">
          Daluyang Dunong Multidisciplinary Research Journal (DDMRJ) Guidelines
        </h1>

        <div class="prose prose-lg max-w-none">
          <!-- About -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">About the Journal</h2>
          <p class="text-gray-600 mb-6">
            <b>Daluyang Dunong</b> (/daˈlujaŋ ˈdunoŋ/, "Channel of Knowledge") is the internationally peer-reviewed,
            open-access, multidisciplinary journal of Mindoro State University (MinSU). It serves as a platform for
            publishing original research across a diverse range of academic fields.
          </p>

          <!-- Aims -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Aims</h2>
          <p class="text-gray-600 mb-6">
            DDMRJ serves as a primary multidisciplinary channel for disseminating high-quality original research and
            scholarly communications. It aims to nurture vibrant academic dialogue, encourage cross-disciplinary
            approaches, and advance knowledge addressing issues of local, national (Philippines), and global significance,
            ensuring impact and rigor through robust peer review.
          </p>

          <!-- Scope -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Scope</h2>
          <p class="text-gray-600 mb-6">
            Daluyang Dunong welcomes submissions of original research articles, review papers, and case studies that fall
            within its broad multidisciplinary mandate. The journal is particularly interested in contributions addressing,
            but not limited to:
          </p>
          <ul class="list-disc list-inside mb-6 text-gray-600">
            <li>Mangyan and Multidisciplinary Indigenous Studies</li>
            <li>Agriculture, Aquaculture, and Agri-Innovation</li>
            <li>Halcon and Highlands Biodiversity Conservation</li>
            <li>AI, Automation, and Advanced Technologies</li>
            <li>Livelihood, Local Economy, and Sustainable Enterprises</li>
            <li>Tamaraw and Terrestrial Wildlife Protection</li>
            <li>Arts, Humanities, and Anthropological Studies</li>
            <li>Naujan Lake and National Resources Management</li>
            <li>Advancement in Health, Human Security, and Holistic Well-being</li>
          </ul>
          <p class="text-gray-600 mb-6">
            Interdisciplinary research that connects these themes and contributes to the Sustainable Development Goals (SDGs)
            in both local and international contexts is highly encouraged.
          </p>

          <!-- Editorial and Peer Review Process -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Editorial and Peer Review Process</h2>
          <ol class="list-decimal list-inside mb-6 text-gray-600">
            <li>
              <b>Initial Screening:</b> Checks for scope alignment, formatting, plagiarism (≤10% similarity), and grammar
              (≥95%).
            </li>
            <li>
              <b>Peer Review:</b> Double-blind review by at least two experts evaluating originality, methodology, clarity,
              and ethics.
            </li>
            <li>
              <b>Reviewer Recommendations:</b> Accept, Minor Revisions, Major Revisions, Reject with Resubmission, or Reject.
            </li>
            <li>
              <b>Editorial Decision:</b> Final decision by Editor-in-Chief, considering reviews, revisions, and ethics.
            </li>
          </ol>

          <!-- Criteria for Acceptance -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Criteria for Acceptance</h2>
          <ul class="list-disc list-inside mb-6 text-gray-600">
            <li>Endorsed by at least two referees</li>
            <li>Complies with ethical research standards</li>
            <li>Similarity ≤ 10% and grammar ≥ 95%</li>
            <li>Significant and original contribution</li>
          </ul>

          <!-- Criteria for Rejection -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Criteria for Rejection</h2>
          <ul class="list-disc list-inside mb-6 text-gray-600">
            <li>Fails initial screening</li>
            <li>Strong rejection recommendations from reviewers</li>
            <li>Inadequate revisions</li>
            <li>Ethical violations</li>
            <li>Outside journal scope</li>
          </ul>

          <!-- Publication Frequency & Funding -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Publication Frequency & Funding</h2>
          <p class="text-gray-600 mb-6">
            Published annually, with occasional special issues. No processing or publication fees. Supported by the MinSU
            Research, Development, and Extension Unit.
          </p>

          <!-- Turnaround Time -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Turnaround Time</h2>
          <p class="text-gray-600 mb-6">
            From submission to first decision: typically 3 months to 1 year, depending on complexity and reviewer
            availability.
          </p>

          <!-- Icon Features -->
          

          <!-- Contact Us -->
          <h2 class="text-2xl font-semibold text-gray-800 mb-4">Contact Us</h2>
          <p class="text-gray-600 mb-4">For inquiries, suggestions, or submissions, please reach out:</p>
          <div class="bg-gray-50 p-6 rounded-lg">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <h4 class="font-semibold text-gray-800 mb-2">General Inquiries</h4>
                <p class="text-gray-600">publication@minsu.edu.ph</p>
              </div>
              <div>
                <h4 class="font-semibold text-gray-800 mb-2">Technical Support</h4>
                <p class="text-gray-600">christian.cabrera@minsu.edu.ph</p>
                <h4 class="font-semibold text-gray-800 mb-2">Web Developer/Master</h4>
                <p class="text-gray-600"><a href="https://facebook.com/iamchristiancabrera">Christian I. Cabrera</a></p>
                <p class="text-gray-600">College of Computer Studies</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MRJGuidelinesView"
};
</script>
